import React from 'react';

import { useTranslation } from '../../common/hooks/useTranslation';

interface InstructionContentProps {
  pl: React.ReactNode;
  en: React.ReactNode;
}

export const InstructionContent: React.FC<InstructionContentProps> = ({
  pl,
  en,
}) => {
  const { i18n } = useTranslation('commonLng');
  return i18n.language.toLowerCase().startsWith('en') ? <>{en}</> : <>{pl}</>;
};
